import React from 'react';
import { useBrowserOrAccountLocale } from './useBrowserOrAccountLocale';
import { getL10nDef } from '../i18n/localization';

export const useL10n = () => {
    const locale = useBrowserOrAccountLocale();
    const l10n = getL10nDef(locale);

    return { locale, l10n };
};
